import React, { FC } from 'react'
import './index.scss'
interface IProps {
  data: any;
}

const PointNumebr: FC<IProps> = (props: IProps) => {
  const { data } = props
  return (
    <div className='point-number-show'>
      <div className='points'>{data.points >= data.collectPointTarget ? data.collectPointTarget : data.points}</div>
      {
        data.points >= data.collectPointTarget
          ? (
            <div className='point-img-block'>
              <div
                className='point-img'
                style={{
                  backgroundImage: `Url(${data.extra?.iconEnable || '/resources/images/collectPoint/cup.png'})`,
                }}
              >
              </div>
            </div>
          ) : (
            <>
              <div className='line'></div>
              <div className='total'>{data.collectPointTarget}</div>
              <div
                className='point-img'
                style={{
                  backgroundImage: `Url(${data.extra?.iconEnable || '/resources/images/collectPoint/cup.png'})`,
                }}
              >
              </div>
            </>
          )
      }
    </div>
  )
}
export default PointNumebr
